import API_BASE from "../config/api";

const STORAGE_KEY = "dn_admin_token";

export function getAdminToken() {
    return sessionStorage.getItem(STORAGE_KEY) || "";
}

export function setAdminToken(token) {
    sessionStorage.setItem(STORAGE_KEY, token);
}

export function clearAdminToken() {
    sessionStorage.removeItem(STORAGE_KEY);
}

export async function adminLoginFromSession(personaluid) {
    const res = await fetch(`${API_BASE}/api/admin_session_from_login.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ personaluid }),
    });
    const data = await res.json();
    if (data.success) setAdminToken(data.token);
    return data;
}

/* fetch() wrapper that attaches the admin token header. On a 401
   (expired/missing session) it clears the stored token so AdminPanel
   can show the login form again on next render. */
export async function adminFetch(url, options = {}) {
    const request = () => fetch(url, {
        ...options,
        headers: { ...(options.headers || {}), "X-Admin-Token": getAdminToken() },
    });

    let res = await request();
    if (res.status !== 401) return res;

    clearAdminToken();
    const localUser = JSON.parse(localStorage.getItem("user") || "{}");
    if (!localUser.personaluid) return res;

    const refreshed = await adminLoginFromSession(localUser.personaluid);
    if (!refreshed.success) return res;
    return request();
}
